import { z } from "zod";

import { fillTemplate } from "../values/fill-template";
import copyJson from "./inventory-copy.json";

const text = z.string().min(1);

const copySchema = z.object({
  transactionTypeLabels: z.object({
    PURCHASE: text,
    SALE: text,
    USAGE: text,
    DISPOSAL: text,
    OPENING_BALANCE: text,
    CORRECTION: text,
    BATCH_SPLIT: text,
  }),
  transactionValidation: z.object({
    typeForbidden: text,
    supplierNotFound: text,
    supplierInvalid: text,
    legacySupplierNotFound: text,
    purchaserNotFound: text,
    purchaserInvalid: text,
    legacyPurchaserNotFound: text,
    finalCountedRequired: text,
    finalCountedNonnegative: text,
    quantityPositive: text,
    correctionEditForbidden: text,
    correctionDeleteForbidden: text,
  }),
  initialStock: z.object({
    supplierRequired: text,
    typeInvalid: text,
    dateRequired: text,
    dateInvalid: text,
    dateFuture: text,
  }),
  reclassification: z.object({ notAllowed: text }),
  batchSplit: z.object({ noChildren: text, overdraw: text }),
  unitConversion: z.object({ unsupported: text, incompatible: text }),
  chemicals: z.object({
    batchNumberExists: text,
    deleteFailed: text,
    manageDocumentsDenied: text,
    deleteDocumentVersionDenied: text,
  }),
  noOrganization: text,
});

const copy = copySchema.parse(copyJson);

export const TRANSACTION_TYPE_LABELS = copy.transactionTypeLabels;
export const TRANSACTION_MESSAGES = copy.transactionValidation;
export const INITIAL_STOCK_COPY = copy.initialStock;
export const RECLASSIFICATION_COPY = copy.reclassification;
export const CHEMICAL_ROUTE_MESSAGES = copy.chemicals;
export const NO_ORGANIZATION_MESSAGE = copy.noOrganization;

export const BATCH_SPLIT_COPY = {
  noChildren: copy.batchSplit.noChildren,
  overdraw: (requested: string, available: string) => fillTemplate(copy.batchSplit.overdraw, { requested, available }),
} as const;

export function unsupportedUnitConversionMessage(from: string, to: string): string {
  return fillTemplate(copy.unitConversion.unsupported, { from, to });
}

export function incompatibleUnitConversionMessage(from: string, to: string): string {
  return fillTemplate(copy.unitConversion.incompatible, { from, to });
}
